import { useState } from 'react';

export type SortDirection = 'asc' | 'desc';

export function useTableSort<F extends string>() {
    const [sortField, setSortField] = useState<F | null>(null);
    const [sortDirection, setSortDirection] = useState<SortDirection>('asc');

    const toggleSort = (field: F) => {
        if (sortField !== field) {
            setSortField(field);
            setSortDirection('asc');
        } else if (sortDirection === 'asc') {
            setSortDirection('desc');
        } else {
            setSortField(null);
        }
    };

    return { sortField, sortDirection, toggleSort };
}
